import React, { SyntheticEvent, useContext, useState } from "react";
import { NavLink, Navigate } from "react-router-dom";
import { ApiResponse, callApi } from "../api/ApiUtilities";
import LoginError from "../components/login/LoginError";
import { SLinkContext } from "../state/context";

function ForgotView() {
  const { state } = useContext(SLinkContext);
  const [submiting, setSubmiting] = useState(false);
  const [error, setError] = useState("");
  const [username, setUsername] = useState("");

  function onSubmit(event: SyntheticEvent) {
    setSubmiting(true);
    event.preventDefault();
    setError("");

    callApi<string>("/api/auth/forgot", "POST", { username: username })
      .catch((error: Error) => {
        setError(`Error requesting a password reset, refresh your screen and try again (${error.message})`);
      })
      .then((res: ApiResponse<string> | void) => {
        if (res) {
          setError(res.message);
        }
        setSubmiting(false);
      });
  }

  if (state.user) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <div className="sl-auth">
      <div className="d-flex">
        <img className="mx-auto" src="/imgs/ADoM-logo-216-colour.png" width="132" height="75" alt="Anglican Diocese of Melbourne" />
      </div>
      <h1 className="sl-auth-title">Forgot password</h1>
      <p className="sl-auth-subtitle">Enter your email address and we'll send you a link to set a new password.</p>

      <main className="sl-auth-card">
        <form onSubmit={onSubmit}>
          <div className="form-floating mb-3">
            <input
              type="email"
              className="form-control"
              id="forgotEmail"
              placeholder="name@example.com"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <label htmlFor="forgotEmail">Email address</label>
          </div>

          <button disabled={submiting} className="w-100 btn btn-lg btn-primary" type="submit">
            {submiting ? "Please wait..." : "Send reset link"}
          </button>

          <LoginError error={error} />

          <p className="mt-3 mb-0 text-center">
            <NavLink to="/login">Back to sign in</NavLink>
          </p>
        </form>
      </main>
    </div>
  );
}

export default ForgotView;
